import ip from 'ip'

export const testTablet = {
	device_name: 'DEV',
	type: 'demoTablet',
	// TODO: need to register with something other than esper_id
	esper_id: 'NAMA', // process.env.REACT_APP_ESPER_ID,
	wifi_mac: undefined,
	serial_number: undefined,
	server_public_ip: ip.address(),
	server_host: ip.address(),
	LOGDNA_LOG_LEVEL: 'info',
	FRIDGE_LOG_LEVEL: 'info',
}
